import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  CONTACT_SUPPORT_TEL,
  CONTACT_SUPPORT_TEL_2,
  CONTACT_SUPPORT_TEL_4,
} from 'shared/constants';
import { Link } from 'react-router-dom';
import './ContactSupport.scss';

const ContactSupport = () => {
  const { t } = useTranslation();
  return (
    <div className="contact-support-container">

      {/* Headings */}
      <h6>{t('profile.contactSupport.heading1')}</h6>
      <h6>{t('profile.contactSupport.heading2')}</h6>

      {/* Row 1 — line space after heading */}
      <div className="text-pacific-blue cs-row-top">
        <a href={`tel:${CONTACT_SUPPORT_TEL}`}>
          <i className="material-icons">phone</i>
          <span>{t('profile.contactSupport.callUsLabel')} </span>
          <span className="support-number">{CONTACT_SUPPORT_TEL}</span>
        </a>
      </div>
      <div className="helper-text cs-row-top">{t('profile.contactSupport.helperText')}</div>

      {/* Row 2 — line space after row 1 */}
      <div className="text-pacific-blue cs-row-top">
        <Link to="/email-us">
          <i className="material-icons">email</i>
          <span>{t('profile.contactSupport.emailUsLabel')}</span>
        </Link>
      </div>
      <div className="cs-row-top">
        <span className="text-pacific-blue">
          <i className="material-icons">email</i>
          <span>{t('profile.contactSupport.emailUsLabel')} - State:</span>
        </span>
        <span style={{ fontWeight: 'bold' }}> {t('profile.contactSupport.email1')}</span>
      </div>

      {/* Row 3 — no line space */}
      <div />
      <div>
        <span className="text-pacific-blue">
          <i className="material-icons">email</i>
          <span>{t('profile.contactSupport.emailUsLabel')} - District:</span>
        </span>
        <span style={{ fontWeight: 'bold' }}> {t('profile.contactSupport.email2')}</span>
      </div>

      {/* Row 4 — line space after row 3 */}
      <div className="call-us cs-row-top">
        {t('profile.contactSupport.callUsLabel')} <span>{CONTACT_SUPPORT_TEL_2}</span>
      </div>
      <div className="call-us cs-row-top">
        {t('profile.contactSupport.callUsLabel')} <span>{CONTACT_SUPPORT_TEL_4}</span>
      </div>

    </div>
  );
};

export default ContactSupport;
